<template>
  <div class="block block--white mt-3">
    <div class="d-flex">
      <div class="col-lg-5 model-data">
        <div class="title model-info">
          {{ name }}
          <span>Videos</span>
        </div>
        <h3 class="description mt-3 model-info">
          {{ description }}
        </h3>
        <p class="ml-5 mt-3 text model-info">
          {{ text }}
        </p>
      </div>
      <div class="col-lg-7 col-sm-12 col-12 col-md-7">
        <BoxVideo
          v-if="videoSelect"
          ref="boxVideo"
          :video="videoSelect"
          :thumbVideo="thumbVideo"
          :posterTime="posterTime"
          @showModalMessages="(val) => showModalMessages(val)"
        />
        <div class="row d-flex buttons-video bg-white py-2 px-4">
          <div
            class="parts col-lg-2 col-4 d-flex justify-content-center align-items-center"
          >
            <select
              class="form-select py-2"
              aria-label="Default-select-parts"
              v-model="sessionIndex"
            >
              <option selected disabled>{{ translate.sessions }}</option>
              <option
                :value="index"
                v-for="(shoot, index) in shoots"
                :key="shoot.name"
              >
                {{ shoot.name }}
              </option>
            </select>
          </div>
          <div
            class="col-lg-2 col-5 justify-content-center align-items-center div-resolution"
            v-if="videoSelect"
          >
            <select
              class="form-select py-2"
              aria-label="Default-select-resolution"
              v-model="videoIndex"
            >
              <option selected disabled>{{ translate.resolution }}</option>
              <option
                :value="index"
                v-for="(video, index) in videos"
                :key="video.name"
              >
                {{ video.name }}
              </option>
            </select>
          </div>
          <div v-else class="col-lg-1 col-5">&nbsp;</div>

          <div
            id="btn-download-video"
            class="col-lg-2 col-2 d-flex justify-content-center align-items-center mobile-download"
            @click="modalConfirmDownload(partId)"
            v-if="videoSelect"
          >
            <button
              type="button"
              class="btn btn-outline-secondary btn-lg px-2 btn-desktop"
            >
              <span class="video-options">{{ translate.download }}</span>
              <font-awesome
                :icon="['fas', 'download']"
                size="md"
                style="color: #b20000; margin-left: 3px"
              />
            </button>
            <font-awesome
              :icon="['fas', 'download']"
              size="md"
              style="color: #b20000; margin-left: 3px"
            />
          </div>

          <div
            class="col-lg-3 col-1 d-flex justify-content-center align-items-center mobile-bellacloud"
            v-if="videoSelect"
          >
            <button
              @click="showModalModelBellacloud(true)"
              type="button"
              class="btn btn-outline-secondary btn-lg px-2 btn-desktop"
            >
              <span class="video-options">{{ translate.saveBellaCloud }}</span>
              <font-awesome
                :icon="['far', 'bookmark']"
                size="md"
                style="color: #b20000; margin-left: 3px"
              />
            </button>
            <font-awesome
              @click="showModalModelBellacloud(true)"
              :icon="['far', 'bookmark']"
              size="md"
              style="color: #b20000; margin-left: 3px"
            />
          </div>
        </div>
        <div class="row d-flex px-1 pb-5">
          <div
            class="cursor-pointer col-xl-3 col-6"
            v-for="(shoot, index) in shoots"
            :key="shoot.name"
          >
            <template v-if="shoot.videos.length" >
              <div
                class="d-flex align-items-center justify-content-center title-part"
                @click="changePart(index)"
              >
                <p :class="['text1', { 'text1-active': sessionIndex === index }]">{{ shoot.name }}</p>
                <span :class="['dropdown-toggle', { 'dropdown-toggle-right': sessionIndex !== index }]"></span>
              </div>
              <div
                class="box-live"
                @click="changePart(index)"
                :style="`background-image: url(${shoot.partThumb});background-size: cover;background-repeat: no-repeat;background-position: 50% 20%;`"
              ></div>              
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalModelBellacloud
    @showModalModelBellacloud="showModalModelBellacloud"
    :showCloud="showCloud"
    :imageIdSelected="partId"
    :video="true"
  />
  <ModalModelPartsVideo
    @showModalModelPartsVideo="showModalModelPartsVideo"
    :showPartsVideo="showPartsVideo"
    :parts="shoots"
    :videosIndex="videoIndex"
    :translate="translate"
    @changeResolution="changeResolutionMobile"
  />
  <ModalMessages
    @showModalMessages="showModalMessages"
    @solicitaDownload="solicitaDownload"
    :options="options"
    :width="isMobile() ? '95%' : '600px'"
  />
  <ModalVideoMessage
    :showModalVideo="showModalVideo"
    @closeModalVideo="closeModalVideo"
  />
</template>

<script lang="ts" setup>
import ModalModelBellacloud from "@/components/Modais/ModalModelBellacloud.vue";
import ModalModelPartsVideo from "@/components/Modais/ModalModelPartsVideo.vue";
import ModalMessages from "@/components/Modais/ModalMessages.vue";
import BoxVideo from "./BoxVideo.vue";
import api from "@/api";
import translateModel from "@/tradutors/model";
import ModalVideoMessage from "~/components/Modais/ModalVideoMessage.vue";
import { isMobile } from "~/shared/utils/mobile";
import {
  indiceDaQualidade,
  videoPlayerTools,
  type ControleDoVideo,
} from "@/composables/webmcp/tools.media";
const route = useRoute();

const translate = computed(() =>
  route.params.language == "pt-br"
    ? translateModel.portugues
    : translateModel.ingles,
);

const props = defineProps({
  model: {
    type: Object,
    default: null,
  },
  videosModel: {
    type: Object,
    default: null,
  },
  posterTime: {
    type: Number,
    default: 30,
  },
});

interface VideoPath {
  id: string;
  videoPath: string;
  name: string;
  urlPanda: string;
}
const showModalVideo = ref(false);
const videoIndex = ref(0);

const videoSelect = ref<VideoPath | false>(
  props.videosModel.shoot[0].videos.length
    ? props.videosModel.shoot[0].videos[0]
    : false,
);

const selectResolution = ref("360p");
const showCloud = ref(false);
const showPartsVideo = ref(false);
const sessionIndex = ref(0);

const videos = computed(() => {
  const videoList = props.videosModel.shoot[sessionIndex.value].videos;
  if (
    props.videosModel.shoot[sessionIndex.value].has4K &&
    !videoList.find((video: any) => video.name === "4K")
  ) {
    videoList.push({
      id: "",
      videoPath: "",
      name: "4K",
      urlPanda: "",
    });
  }
  return videoList;
});

const name = computed(() => props.model.nameModel);
const description = computed(() => props.model.descriptionModel);
const text = computed(() => props.model.text);
const shoots = computed(() => props.videosModel.shoot);
const partId = computed(() => props.videosModel.shoot[sessionIndex.value].id);

const options = ref({
  showModal: false,
  titleModal: "",
  textBoby: "",
  textBodyModal: "",
  textButtonModal: "",
  routerName: "",
  functionOptions: null,
  showClose: false,
});

const thumbVideo = computed(
  () => props.videosModel.shoot[sessionIndex.value].partThumb,
);

watch(
  () => videoIndex.value,
  (value) => {
    if (
      videos.value[value]?.name == "4K" &&
      videos.value[value]?.videoPath == ""
    ) {
      videoIndex.value = 0;
      showModalVideo.value = true;
      return false;
    }
    videoSelect.value = videos.value[value];
    selectResolution.value = videos.value[value]?.name;
  },
);

watch(
  () => sessionIndex.value,
  () => {
    videoSelect.value = videos.value[0] || null;
    videoIndex.value = 0;
    selectResolution.value = videos.value[0]?.name;
  },
);

onMounted(() => {
  getModel();
});

function closeModalVideo() {
  showModalVideo.value = false;
}

function getModel() {
  videoIndex.value = Number(
    videos.value.indexOf(
      videos.value.find((currObj: any) => {
        return currObj.name === "HD 720p";
      }),
    ),
  );

  if (videoIndex.value < 0) videoIndex.value = Number(videos.value.length - 2);
}

function showModalMessages(data: any) {
  options.value.showModal = data.message.show;
  options.value.titleModal = data.message.title;
  options.value.textBodyModal = data.message.textBoby;
  options.value.textButtonModal = data.message.textButton;
  options.value.routerName = data.message.routerName;
  options.value.functionOptions = data.message.functionOptions;
  options.value.showClose = data.message.showClose;
}
function showModalModelBellacloud(value: boolean) {
  showCloud.value = value;
}
function showModalModelPartsVideo(value: boolean) {
  showPartsVideo.value = value;
}
function changeResolutionMobile(resolution: number) {
  videoSelect.value = videos.value[resolution];
  selectResolution.value = videos.value[resolution].name;
  videoIndex.value = resolution;
}
function modalConfirmDownload(id: number) {
  showModalMessages({
    message: {
      show: true,
      title:
        route.params.language == "en"
          ? "Click CONFIRM DOWNLOAD to confirm that you want to download the video"
          : "Clique em CONFIRMAR DOWNLOAD para confirmar que você deseja baixar o vídeo",
      textButton:
        route.params.language == "en"
          ? "CONFIRM DOWNLOAD"
          : "CONFIRMAR DOWNLOAD",
      textBoby:
        route.params.language == "en"
          ? "This video will use 1 credit from your account"
          : "Este vídeo utilizará 1 crédito da sua conta",
      functionOptions: { name: "solicitaDownload", parameter: id },
      showClose: true,
    },
  });
}
async function solicitaDownload(id: number) {
  api
    .get(
      "v1/videoscredits/solicitaDownload/video/" +
        id +
        `?locale=${route.params.language ?? "pt-br"}`,
    )
    .then(({ data }) => {
      if (!data.error)
        showModalMessages({
          message: {
            show: true,
            title:
              route.params.language == "en"
                ? "Your download is being processed!"
                : "Seu download está sendo processado!",
            textButton: route.params.language == "en" ? "Close" : "Fechar",
            textBoby: data.message,
          },
        });
      else if (
        data.message.includes("Adquira créditos para realizar o download") ||
        data.message.includes("Purchase credits in order to download")
      ) {
        showModalMessages({
          message: {
            show: true,
            title:
              route.params.language == "en"
                ? "Error your download!"
                : "Falha ao solicitar download!",
            textButton:
              route.params.language == "en"
                ? "BUY CREDITS"
                : "COMPRAR CRÉDITOS",
            textBoby: data.message,
            routerName: "language-assine",
          },
        });
      } else {
        showModalMessages({
          message: {
            show: true,
            title:
              route.params.language == "en"
                ? "Error your download!"
                : "Falha ao solicitar download!",
            textButton: route.params.language == "en" ? "Close" : "Fechar",
            textBoby: data.message,
          },
        });
      }
    })
    .catch((err) => {
      showModalMessages({
        message: {
          show: true,
          title:
            route.params.language == "en"
              ? "Error your download!"
              : "Falha ao solicitar download!",
          textButton: route.params.language == "en" ? "Close" : "Fechar",
          textBoby: err.response.data.message,
        },
      });
    });
}

function changePart(index: number) {
  sessionIndex.value = index;
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// WebMCP: control_video e choose_video, vivas só enquanto este player estiver
// na tela. Usam os mesmos seletores de parte e resolução da página e o Plyr do
// BoxVideo. O 4K sem caminho, que aqui abre o aviso de upgrade, volta para o
// agente como texto, sem abrir nada.
const boxVideo = ref<any>(null);
const controleDoVideo: ControleDoVideo = {
  tipo: "video",
  player: () => boxVideo.value?.player?.() ?? null,
  estado: () => ({
    previa: false,
    parte: sessionIndex.value,
    partes: shoots.value.map((shoot: any) => ({
      nome: String(shoot.name ?? ""),
      temVideo: Boolean(shoot.videos?.length),
    })),
    qualidade: videoSelect.value ? videoSelect.value.name : null,
    qualidades: videos.value.map((video: any) => String(video.name)),
  }),
  async escolherParte(indice) {
    const shoot = shoots.value[indice];
    if (!shoot) return "parte-inexistente";
    if (!shoot.videos?.length) return "parte-sem-video";
    sessionIndex.value = indice;
    await nextTick();
    return "ok";
  },
  async escolherQualidade(nome) {
    const indice = indiceDaQualidade(
      videos.value.map((video: any) => String(video.name)),
      nome,
    );
    if (indice < 0) return "qualidade-inexistente";
    const video = videos.value[indice];
    if (video.name === "4K" && !video.videoPath) return "qualidade-4k";
    videoIndex.value = indice;
    await nextTick();
    return "ok";
  },
};
useWebMcpTools((ctx) => videoPlayerTools(ctx, controleDoVideo));
</script>
<style scoped lang="css">
.block {
  padding: 28px 0;
}

#model-video-box {
  width: 827px;
  height: 465px;
}

.fake-player-wait-panda {
  width: 827px;
  height: 465px;
  background-color: #000000;
  position: relative;
}

.model-info {
  padding-left: 137px;
}

h3 h1 p {
  font-family: "Exo-2";
}

.name-video {
  font-family: "Exo-2";
  font-size: 12px;
  font-weight: bold;
  color: #b20000;
}

.title-msg {
  font-family: "Bebas-Neue";
  font-size: 40px;
  font-weight: 400;
  position: absolute;
  z-index: 99;
  color: #ffffff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  background: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 80px;
  line-height: 90px;
  cursor: pointer;
}

.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.text {
  height: 76px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  max-width: 370px;
}

.video-options {
  height: 19px;
  font-family: "Exo-2";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 19px;
}

.row .buttons-video > .col,
.row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.btn-outline-dark {
  font-size: 14px;
  font-weight: 500;
  border-radius: 30px;
}

.btn-outline-secondary {
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  border: none;
}

.parts > .form-select {
  background-color: #fff;
  color: #868686;
  font-size: 14px;
  font-weight: 600;
  font-family: "Exo-2";
  border: none;
  background-image: url("");
  --bs-form-select-bg-img: url("");
  pointer-events: none;
  width: 100px;
}

.form-select {
  background-color: #fff;
  color: #868686;
  font-size: 14px;
  font-weight: 600;
  font-family: "Exo-2";
  border: none;
  cursor: pointer;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAxNiAxNic+PHBhdGggZmlsbD0nbm9uZScgc3Ryb2tlPScjYjIwMDAwJyBzdHJva2UtbGluZWNhcD0ncm91bmQnIHN0cm9rZS1saW5lam9pbj0ncm91bmQnIHN0cm9rZS13aWR0aD0nMicgZD0nbTIgNSA2IDYgNi02Jy8+PC9zdmc+Cg==);
}

.div-resolution > .form-select {
  background-position: left 0.2rem center;
  padding-left: 25px;
  padding-right: 0px;  
}

.form-select:hover {
  background-color: #6c757d;
  color: #fff;
  border-radius: 30px;
  border: none;
}

.mobile-bellacloud > svg,
.mobile-share > svg,
.mobile-download > svg,
.mobile-sections {
  display: none;
}

.model-info span {
  font-family: "Exo-2";
  font-size: 25px;
  line-height: 20px;
  display: block;
  width: 100%;
  font-family: "Bebas-Neue";
}

.box-live {
  width: 100%;
  aspect-ratio: 16 / 9;
}

.dropdown-toggle:after {
  font-family: "fontello";
  font-size: 25px;
  content: "\e809";
  margin: 0;
  border: none;
  vertical-align: text-bottom;
  color: #b20000;
  margin-left: 0px;
}

.text1 {
  font-family: "Exo-2";
  color: #b5b5b5;
  font-size: 15px;
  line-height: 21px;
  font-weight: 600;
  margin-bottom: 5px;
  text-align: center;
}

.text1-active {
  font-weight: bold;
  color: #000;
}

.dropdown-toggle-right:after {
  content: "\e80c";
}

.title-part {
  margin-top: 20px;
}

@media screen and (max-width: 992px) {
  .model-data,
  .btn-desktop {
    display: none;
  }

  .block {
    padding: 0px;
    margin-top: 0px !important;
  }

  .mobile-bellacloud > svg,
  .mobile-share > svg,
  .mobile-download > svg,
  .mobile-sections {
    display: block;
  }

  .row :deep(#model-video-box) {
    margin-bottom: 50px;
  }

  .buttons-video {
    box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
    -webkit-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
    -moz-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
  }

  .name-video {
    font-family: "Exo-2";
    font-size: 14px;
    font-weight: bold;
    color: #000000;
  }

  #model-video-box {
    width: 100%;
    height: unset;
    right: unset;
    margin-left: 10px;
  }

  .fake-player-wait-panda {
    width: 100%;
    height: 30vh;
    right: unset;
    margin-left: 5px;
  }

  .mobile-sections {
    top: -2px;
  }

  .title-msg {
    font-size: 25px;
    height: 50px;
    line-height: 55px;
    transform: translate(-50%, -130%);
  }
}
</style>
